module.exports = {
      id: "automobile-usage",
      viewBox: "0 0 31.664 23.083",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#automobile",
      toString: function () {
        return this.url;
      }
    }